<template>
  <FacilityPage :blok="blok" :story="story" />
</template>

<script setup>
defineProps({
  blok: {
    type: Object,
    required: true,
  },
  story: {
    type: Object,
    required: true,
  },
});
</script>
